import Header from "../parts/header";
import Leftbar from "../parts/leftbarCoaching";
import { ClientConfigAnnouncementModal } from "../parts/modals/ClientConfigAnnouncementModal";
import { CoachCheckinModal } from "../parts/modals/CoachCheckinModal";
import { MsbAgentModal } from "../parts/modals/MsbAgentModal";
import { ReferralLinkProgram } from "../parts/modals/referral-link-program";
import { useRillContext } from "../rill/RillReact/share/base";

function Page({ children }) {
  const { locals } = useRillContext();
  const { activeUser, organizationOwner, query } = locals || {};
  const { modal = {} } = query;

  return (
    <div id="coaching-wrapper">
      {/* biome-ignore lint/a11y/noLabelWithoutControl: toggles the #mobile-nav-toggle checkbox rendered in wrappers/page.js */}
      <label htmlFor="mobile-nav-toggle" />
      <Header coachingPortalEnabled query={query} />
      <Leftbar query={query} />
      {children}
      {modal?.type === "referral-link-program" && (
        <ReferralLinkProgram activeUser={activeUser} />
      )}
      <ClientConfigAnnouncementModal activeUser={activeUser} />
      <MsbAgentModal activeUser={activeUser} />
      <CoachCheckinModal
        activeUser={activeUser}
        organizationOwner={organizationOwner}
      />
    </div>
  );
}

export default Page;
